<template>
  <NuxtLoadingIndicator />
  <slot />
</template>

<script setup></script>

<style lang="scss" scoped></style>
